// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"TravelerRoom_removeButton__5_Vcc"};